import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Point from '../Point/Point';
import style from '../../../styles/styles';
import IconMenu from "material-ui/IconMenu";
import styles from "../../../containers/openexplore/PointPage/PointPage.css";
import MenuItem from "material-ui/MenuItem";
import IconButton from "material-ui/IconButton";
import MoreVertIcon from "material-ui/svg-icons/navigation/more-vert";
import {white} from "material-ui/styles/colors";
import withTranslation from "../../../hoc/withTranslation";
import APIService from "../../../services/api";
import {Cookies} from "react-cookie";
import {CSV} from "../../../constants/format";

const cookies = new Cookies();

const iconButtonElement = (
    <IconButton
        touch={true}
        tooltipPosition="bottom-left"
    >
        <MoreVertIcon color={white} />
    </IconButton>
);

const PointList = (props) => {
    const { points, title, user, app, lang, t } = props;

    let content;

    if (points.length > 0) {
        content = points.map(function(point, index) {
            return <div key={point.id}>
                <Point
                    app={app}
                    user={user}
                    point={point}
                    handleRemovePoint={props.handleRemovePoint}
                />
                {index !== (points.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    const getCsvExport = async() => {
        const response = await APIService.getPoints(
            app,
            cookies.get('token'),
            lang,
            CSV,
            true,
        );
        const type = response.headers['content-type'] || 'text/csv';
        const filename = 'points.csv';
        const blob = new Blob([response.data],
            {
                type: type,
                encoding: 'UTF-8',
            },
        );
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>
                    {title}
                    <IconMenu
                        style={styles.buttons}
                        iconButtonElement={iconButtonElement}
                        anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                        targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    >
                        <MenuItem onClick={getCsvExport}>
                            {t('module.open_explore.export_csv')}
                        </MenuItem>
                    </IconMenu>
                </Subheader>
                {content}
            </List>
        </Paper>
    );
};

PointList.propTypes = {
    points: PropTypes.arrayOf(PropTypes.object).isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    handleRemovePoint: PropTypes.func
};

export default withTranslation(PointList);



// WEBPACK FOOTER //
// src/components/openexplore/PointList/PointList.js